import { connect } from "vuex-connect";
import { CommentList } from "../../../components";

export default connect({
  stateToProps: {
    displayCommentList: state => state.contents.displayCommentList,
    originalCommentList: state => state.contents.originalCommentList,
    moreCommentsFlag: state => state.contents.moreCommentsFlag
  },
  actionsToProps: {
    getCommentList: (dispatch, value) => {
      return dispatch("contents/getCommentList", value);
    }
  },
  mutationsToProps: {
    moreComments: (commit, value) => commit("contents/moreComments", value)
  }
})(CommentList.name, CommentList);
